import React from "react";

function TestimonialCard({ Body, Name, Position, Avatar }) {
  return (
    <div className="p-3 d-flex gap-5 flex-column justify-content-between border border-1 rounded-4 w-100 h-100">
      <div>
        <p className=" m-0 p-0">{Body}</p>
      </div>
      <div className=" d-flex justify-content-start align-items-center gap-2">
        <div>
          <img
            src={Avatar}
            width={55}
            height={55}
            className={`styles.responsiveHero rounded-circle`}
            alt={Name + Position}
          />
        </div>
        <div className=" d-flex flex-column gap-0">
          <span className="m-0 p-0 opacity-75 fw-bold">{Name}</span>
          <span className="  m-0 p-0 opacity-50" style={{ fontSize: "0.8rem" }}>
            {Position}
          </span>
        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;
